class UserSearchInlineInterface {


    selectors;

    constructor() {
        this.selectors = new UserSearchInlineSelectors();
    }


    populateUserFieldsFromJson(holder_element, json_data)
    {

        holder_element.find('.passenger_id').val(json_data.id);
        holder_element.find('.first_name').val(json_data.name);
        holder_element.find('.last_name').val(json_data.last_name);
        holder_element.find('.email').val(json_data.address.email_1);
        holder_element.find('.telephone').val(json_data.address.tel1);

    }
}